// moms-harness:anchor v2
// Spec: docs/spec/settlement/SPEC-settlement-mwp-mlt-sku-attribute-registration-C.yaml
// JIRA: LOGISPRD-13480
/**
 * 라벨에 조사를 붙인다 — `색상` + (은/는) → `색상은`, `바코드` + (은/는) → `바코드는`.
 *
 * 유니코드 한글 음절은 `0xAC00 + (초성×21 + 중성)×28 + 종성` 이므로 `(코드 - 0xAC00) % 28` 이
 * 0 이면 종성이 없다. 종성이 있으면 [withJong], 없으면 [withoutJong] 을 붙인다.
 *
 * ### 조사를 [LABELS] 표나 문구에 적어 두지 않는 이유
 *
 * 라벨이 늘 때마다 사람이 조사를 골라야 하고, **틀려도 컴파일·테스트가 잡지 못한다.** 실제로
 * `상품옵션는`·`상품명는`·`브랜드명는` 셋이 그렇게 틀려 있었고 이 PR 이 `색상는` 을 하나 더
 * 만들었다 (PR #810 1차 봇 리뷰).
 *
 * **보조사(은/는)와 주격조사(이/가) 둘 다 이 함수를 쓴다.** `priceError` 가 `는`·`가` 를
 * 하드코딩하고 있었는데, 지금 호출 라벨(`입고단가`·`출고단가`)이 둘 다 종성이 없어 우연히
 * 맞았을 뿐이다 (PR #810 2차 봇 리뷰). 라벨을 파라미터로 받는 함수가 조사를 강제하면
 * 다른 라벨이 넘어오는 날 틀린다.
 *
 * 한글로 끝나지 않는 라벨(`브랜드ID`)은 읽는 소리를 알 수 없어 두 형태를 함께 적는다
 * (`브랜드ID은(는)`) — 잘못된 조사를 단정해 붙이는 것보다 낫다.
 *
 * **`export` 한 것은 테스트가 이 계산을 직접 잠그기 위해서다.** 호출부로는 잠기지 않는다 —
 * `priceError` 의 라벨 둘이 같은 형태라 계산을 걷어내도 결과가 같다.
 */
export const withParticle = (label: string, withJong: string, withoutJong: string): string => {
  const last = label.charCodeAt(label.length - 1)
  if (last < 0xac00 || last > 0xd7a3) return `${label}${withJong}(${withoutJong})`
  return `${label}${(last - 0xac00) % 28 === 0 ? withoutJong : withJong}`
}
